

import BannerThree from '../components/sections/banners/bannerThree'
import AboutThree from '../components/sections/abouts/aboutThree'
import ChooseUs from '../components/sections/chooseUs'
import AboutTwo from '../components/sections/abouts/aboutTwo'
import AboutOne from '../components/sections/abouts/aboutOne'
import { ScrollRestoration } from 'react-router-dom'
import TestimonialSlider from '../components/sections/testimonialSlider'


const Home = () => {
  return (
    <>
      <BannerThree />
      <AboutThree />
      <ChooseUs />
      <AboutOne />
      <TestimonialSlider />
      <AboutTwo />
      <ScrollRestoration />
    </>
  )
}

export default Home